const circlesStrings = {
  closedCirclesHeader: {
    addClosedCircleBtn: 'Add Circle',
  },

  closedCirclesFilter: {
    searchBarPlaceholder: 'Circle Name',
  },

  closedCirclesList: {
    closedCirclesGridNoResultsFound: 'No results matching your search criteria',
    closedCirclesGridHeader: {
      closedCirclesIdGridHeader: 'ID',
      closedCirclesNameGridHeader: 'Name',
      closedCirclesDescriptionGridHeader: 'Description',
      closedCirclesLogoGridHeader: 'Logo',
      closedCirclesCreationDateGridHeader: 'Date',
      closedCirclesAuthorGridHeader: 'Creator',
      closedCirclesActionsGridHeader: 'Actions',
    },
    approveBtnText: 'Approve',
    imageFileText: 'Image',
    copiedToClipboardText: 'Copied to clipboard 🚀',
    approvetrueActionPopupTitle: 'Are you sure you want to Approve this circle?',
    closedCirclesListActionsPopupYesBtn: 'Yes',
    closedCirclesListActionsPopupNoBtn: 'No',
  },
};

export default circlesStrings;
